import React from 'react'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'

const ViewMore = ({ onClick, viewMore }) => {
  return (
    <div className={generalStyles.pb20}>
      <div className={generalStyles.flexCentered}>
        <button
          onClick={onClick}
          className={classNames(
            generalStyles.flexRow,
            generalStyles.alignVertical,
            generalStyles.hoverGrayBtn,
            {
              [generalStyles.activeIcon]: viewMore
            }
          )}
          style={{
            height: '32px',
            width: '102px',
            justifyContent: 'space-between'
          }}
        >
          <span
            className={
              viewMore
                ? fontStyles.pxsmallboldlsssgraphik12pt
                : fontStyles.pxsmallboldlsssin01lightbasegraphik12pt
            }
          >
            {viewMore ? 'View Less' : 'View More'}
          </span>
          <IcomoonReact
            iconSet={rebrandIconSet}
            icon="Controls-Carrot-Down"
            size={10}
            style={{
              marginRight: 2,
              transform: viewMore ? 'scaleY(-1)' : 'scaleY(1)',
              transition: 'transform 0.3s ease'
            }}
          />
        </button>
      </div>
    </div>
  )
}

export default ViewMore
